import { createFileRoute, Outlet } from '@tanstack/react-router';

import { SourcingOverviewTabs } from '@/areas/sourcing-scenarios/SourcingScenarios/components/SourcingOverviewTabs';
import type { PageStaticData } from '@/shared/routing';

// The overview's views below its tab row. Today's tree has no such layout: the page switches views with cards.
export const Route = createFileRoute('/_authenticated/next/projects/$projectId/sourcing/overview')({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const projectId = Route.useParams({ select: (params) => params.projectId });
    return (
        <SourcingOverviewTabs projectId={projectId}>
            <Outlet />
        </SourcingOverviewTabs>
    );
}
